import cmp from './CustomTabs'

export default cmp
